module.exports = __webpack_public_path__ + "img/0S6A0047.86e478f2.jpg";